import { useSignal, useSignalEffect } from '@preact/signals'
import { For, Show } from '@preact/signals/utils'
import { RepoCard } from '../components/RepoCard.jsx'

export const Explore = () => {
  const { repos, loaded } = useRepos()
  return <main className="container mx-auto px-6 py-8 my-2">
    <Show when={loaded} fallback={<Spinner />}>
      <div className="grid gap-4 md:grid-cols-3">
        <For each={repos} fallback={<NoRepos />}>
          {(repo, index) => <RepoCard key={index} repo={repo} />}
        </For>
      </div>
    </Show>
  </main>
}

export const NoRepos = () => 
  <div className="text-center py-8">
    <p className="text-zinc-400">No repositories found</p>
  </div>


export const Spinner = () => 
  <div className="text-center py-8">
    <div className="animate-spin rounded-full h-8 w-8 border-2 border-red-500 border-t-transparent mx-auto"></div>
  </div>

export const useRepos = () => {
  const repos = useSignal([])
  const loaded = useSignal(false)

  useSignalEffect(async () => {
    const data = await fetch('/api/repos').then(res => res.ok ? res.json() : [])
    loaded.value = true
    repos.value = data.filter(Boolean)
  })

  return { repos, loaded }
}